import React from 'react';
import clsx from 'clsx';

const DataCard = ({ data, selectedProject }) => (
  <div className="blueBorderStyle" style={{ width: '23%', margin: '1%', height: '250px', overflowY: 'hidden' }}>
    <div
      style={{
        display: 'flex',
        width: '100%'
      }}
      className={clsx('titlePopUp2', 'paddingTitle2')}
    >
      <span>{data.attributeName}</span>
    </div>
    <div className={clsx('paddingTitle2')} style={{ overflowY: 'auto', height: '82%' }}>
      <DataAttributes attributes={data.schema} />

      <Actions actions={data.actions} selectedProject={selectedProject} />
    </div>
  </div>
);

const DataAttributes = ({ attributes }) => {
  const listAttributes = attributes.map((attribute) => (
    <AttributeListItem attribute={attribute} key={attribute.entryName + attribute.entryType} />
  ));
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span style={{ width: '50%', display: 'flex' }} className={clsx('lightBlue', 'bold')}>
        Attributes
      </span>
      <hr className={clsx('blueLine2', 'spacingTopDiv')} />
      <ul
        className={clsx('spacingTopDiv', 'spacingDownDiv')}
        style={{
          listStyleType: 'none'
        }}
      >
        {listAttributes}
      </ul>
    </div>
  );
};

const AttributeListItem = ({ attribute }) => (
  <>
    {' '}
    {attribute.values ? (
      <CheckBoxTagItem attribute={attribute} />
    ) : (
      <InputTagItem attribute={attribute} />
    )}{' '}
  </>
);
const InputTagItem = ({ attribute }) => (
  <li>
    <span className={clsx('bold')}> {attribute.entryName} :&nbsp;</span> {attribute.table ? '[' : ''} {attribute.entryType}{' '}
    {attribute.table ? '] ' : ''} {attribute.entityName ? attribute.entityName : ''}
  </li>
);

const CheckBoxTagItem = ({ attribute }) => {
  const enumValue = attribute.values.map((value) => (
    <li key={value} style={{ marginRight: '10%' }}>
      {value}
    </li>
  ));
  return (
    <li>
      <span className={clsx('bold')}> {attribute.entryName} :</span> {attribute.entryType}
      <div style={{ display: 'flex', flexDirection: 'row', marginLeft: '10%' }}>
        <span> Values : </span>
        <ul
          style={{
            display: 'flex',
            flexDirection: 'row',
            listStyleType: 'none',
            marginLeft: '5%'
          }}
        >
          {enumValue}
        </ul>
      </div>
    </li>
  );
};

const Actions = ({ actions }) => {
  const actionsList = actions.map((action) => (
    <ActionListItem key={action.UIProps.id} action={action} />
  ));
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }} className={clsx('spacingTopDiv')}>
      <span style={{ width: '50%', display: 'flex' }} className={clsx('lightBlue', 'bold')}>
        Actions
      </span>
      <hr className={clsx('blueLine2', 'spacingTopDiv')} />
      <ul
        className={clsx('spacingTopDiv', 'spacingDownDiv')}
        style={{
          listStyleType: 'none'
        }}
      >
        {actionsList}
      </ul>
    </div>
  );
};

const ActionListItem = ({ action }) => {
  let actionComponent = '';
  if (action.internalAction?.changePage) {
    actionComponent = (
      <InternalActions internal={action.internalAction} />
    );
  } else if (action.externalAction?.linkHref) {
    actionComponent = <ExternalActions external={action.externalAction} />;
  } else if (action.customCode?.functionName) {
    actionComponent = <CustomFunction functionDesc={action.customCode} />;
  } else {
    actionComponent = '';
  }
  return (
    <li className={clsx('spacingDownDiv', 'item-list-line-slpit')}>
      <span className={clsx('bold')}>{action.actionName} </span>
      <div>{actionComponent}</div>
    </li>
  );
};

const findTargetPage = (id) => {

  const selectedProject = JSON.parse(localStorage.getItem('selectedProject'));
  let targetPageName = -1;

  if(selectedProject > -1){
    const tempData = JSON.parse(localStorage.getItem('data'))[selectedProject].pages;
  
    tempData.forEach((page) => {
      if (page.pageId === id) {
        targetPageName = page.name;
      }
    });
  }
  return targetPageName;
};

const InternalActions = ({ internal }) => (
  <p>change page: {findTargetPage(internal.changePage)}</p>
);

const ExternalActions = ({ external }) => (
  <p>
    {external?.method ? external.method : 'go to link'}: {external.linkHref}
  </p>
);

const CustomFunction = ({ functionDesc }) => <p>method: {functionDesc.functionName}</p>;

export default DataCard;
